import { ContextMenuItem } from "lib/@components/context-menu-bar/context-menu-item"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { confirm } from "lib/@dialogs/confirm"
import { alert } from "lib/@dialogs/alert"
import { busyWhile } from "lib/@components/busy/busy-while"
import { waitForScheduleRefresh } from "routes/schedule/lib/wait-for-schedule-refresh"
import { getSchedulesRegimeUsage } from "routes/schedule/my-schedules/my-custom-schedules/controller/get-schedules-regime-usage"
import { deleteRetiredSchedules } from "routes/schedule/my-schedules/my-custom-schedules/controller/delete-retired-schedules"

export function DeleteRetired() {
    const { target } = useBoundContext()
    return (
        <ContextMenuItem
            icon="gravity-ui:trash-bin"
            label="Delete"
            onClick={remove}
            data-cy="menu-item-delete-retired"
        />
    )

    async function remove() {
        const usage = await getSchedulesRegimeUsage([target._id])
        if (usage.length) {
            await alert("This schedule can't be deleted because it's used by a regime.", "Can't delete")
            return
        }
        const ok = await confirm(
            "This schedule will move to the Recycle Bin, where you can restore it.",
            "Delete retired schedule",
            undefined,
            "Delete",
            { okColor: "error", okIcon: "gravity-ui:trash-bin", cancelIcon: "mdi:close-circle-outline" }
        )
        if (!ok) return
        await busyWhile(() => deleteRetiredSchedules([target._id]), "Deleting", waitForScheduleRefresh)
    }
}
